/**
 * These names are appended to `KAGGLE_PORTAL_ROOT_PREFIX` to form IDs (use lower-dash-case for string).
 * By default you should not explicitly use this and rely on the global root.
 * Certain cases require rendering to a relative positioned area in a specific point of the React tree.
 * When this is amended, new cases should have doc comment clarifying necessity.
 */ export var PortalRootName;
(function(PortalRootName) {
    PortalRootName[/** The global portal root at the root of the React tree (absolute positioned). */ "GLOBAL"] = "global";
    PortalRootName[/** Relatively positioned container on the right-rail of the page to push page content over. */ "RIGHT_RAIL"] = "right-rail";
})(PortalRootName || (PortalRootName = {}));
